import ReactGA from "react-ga4";

export function mergeTimeAndDate(dateString, timeString) {
  const date = new Date(dateString);
  const [time, meridiem] = timeString.split(" ");
  const [hours, minutes] = time.split(":").map(Number);
  const adjustedHours = meridiem === "AM" ? hours : hours + 12;
  date.setHours(adjustedHours);
  date.setMinutes(minutes);
  return date;
}

export function validatePhoneNumber(phoneNumber) {
  const numericPhoneNumber = phoneNumber.replace(/\D/g, "");
  if (numericPhoneNumber.length === 11) {
    if (numericPhoneNumber.startsWith("1")) {
      return true;
    }
  }
  return false;
}

export function storeData(key, data) {
  localStorage.setItem(key, JSON.stringify(data));
}

export function retrieveData(key) {
  const data = localStorage.getItem(key);
  return JSON.parse(data);
}

export function processArray(array) {
  if (array.length < 2) {
    return null;
  }
  if (
    array[0].lat === null ||
    array[0].lng === null ||
    array[array.length - 1].lat === null ||
    array[array.length - 1].lng === null
  ) {
    return null;
  }

  const origin = array[0];
  const destination = array[array.length - 1];
  const inBetweenArray = array.slice(1, array.length - 1);

  return {
    origin: origin,
    destination: destination,
    inBetweenArray: inBetweenArray,
  };
}

export function checkArray(array) {
  if (
    array[0].lat === null ||
    array[0].lng === null ||
    array[array.length - 1].lat === null ||
    array[array.length - 1].lng === null
  ) {
    return false;
  } else {
    return true;
  }
}

export function trackStepCompletion(stepNumber) {
  ReactGA.event({
    category: "Stepper",
    action: `Step ${stepNumber} Completed`,
  });
}

export function pageViewed(step) {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.href,
    title: `Generate Quote Form ${step}`,
  });
}

export const getOrdinal = (n) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};
